<template>
  <div class="feature">
    <img :src="require('@/assets/netherlands/' + svgPath + '.svg')" />
    <h5 class="title">{{ $t(title) }}</h5>
    <p class="text">{{ $t(text) }}</p>
  </div>
</template>

<script>
export default {
  props: ['title', 'text', 'svgPath'],
};
</script>

<style scoped>
.feature {
  box-shadow: 0px 2px 20px #0000001a;
  margin-top: 2em;
  padding: 2em;
}
.title {
  margin-top: 10px;
  margin-bottom: 17px;
  font-size: 14px;
  font-family: 'Foco';
  font-weight: bold;
  letter-spacing: 0px;
  color: #2b4047;
  opacity: 1;
}
.text {
  font-size: 14px;
  font-family: 'Lato';
  letter-spacing: 0px;
  color: #2b4047;
}
@media (min-width: 768px) {
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 20px;
  }
}
</style>
